// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependencies
import * as THREE from 'three';
import PropTypes from 'prop-types';

// Internal Dependencies
import Draggable from './Draggable';
import { MallMapManageButtons } from '../../../common/constants';
import { useMallMapStore } from '../../../hook/useMallMapStore';
import Images from '../../basics/Images';

const regularBoxSize = [0.3, 24];
const enlargedBoxSize = [0.45, 24];

const Waypoint = (props) => {
  const { selectedButton, updateLogo } = useMallMapStore((state) => state);
  const color = props.id === props.selectedId ? 'green' : props.logo ? 'white' : 'gold';

  let defaultLogo = '';
  switch (props.type) {
    case 'ATM':
      defaultLogo = Images.Local.MallNavigation.ATM;
      break;
    case 'Babycare':
      defaultLogo = Images.Local.MallNavigation.Babycare;
      break;
    case 'Escalator':
      defaultLogo = Images.Local.MallNavigation.Escalator;
      break;
    case 'Female Toilet':
      defaultLogo = Images.Local.MallNavigation.FemaleToilet;
      break;
    case 'Gate':
      defaultLogo = Images.Local.MallNavigation.Gate;
      break;
    case 'Handicap Toilet':
      defaultLogo = Images.Local.MallNavigation.HandicapToilet;
      break;
    case 'Information':
      defaultLogo = Images.Local.MallNavigation.Information;
      break;
    case 'Lift':
      defaultLogo = Images.Local.MallNavigation.Lift;
      break;
    case 'Male Toilet':
      defaultLogo = Images.Local.MallNavigation.MaleToilet;
      break;
    case 'Path':
      defaultLogo = Images.Local.MallNavigation.Path;
      break;
    case 'Salat Room':
      defaultLogo = Images.Local.MallNavigation.SalatRoom;
      break;
    case 'Staircase':
      defaultLogo = Images.Local.MallNavigation.Staircase;
      break;
    case 'Store':
      defaultLogo = Images.Local.MallNavigation.Store;
      break;
    case 'Taxi Stand':
      defaultLogo = Images.Local.MallNavigation.TaxiStand;
      break;
    default:
  }

  const textureLoader = new THREE.TextureLoader();

  const [boxSize, setBoxSize] = useState(regularBoxSize);
  const [map, setMap] = useState(textureLoader.load(defaultLogo));

  const enlargeBox = () => setBoxSize(enlargedBoxSize);
  const reduceBoxToRegularSize = () => setBoxSize(regularBoxSize);

  const handlePointerDown = () => {
    enlargeBox();
    props.setIsMapControlEnabled(false);
  };

  const handlePointerUp = () => {
    reduceBoxToRegularSize();
    props.setIsMapControlEnabled(true);
  };

  const handlePointerMove = () => {
    props.setIsMapControlEnabled(false);
  };

  useEffect(() => {
    if (props.logo) {
      const rand = `?${Math.random()}`;
      setMap(textureLoader.load(props.logo + rand));
    } else {
      setMap(textureLoader.load(defaultLogo));
    }
  }, [updateLogo]);

  return (
    <Draggable name={props.id.toString()} enableMove={selectedButton === MallMapManageButtons.MANAGE_WAYPOINTS}>
      <mesh
        position={[props.position[0], props.position[1], props.position[2]]}
        onClick={(e) => props.onClick(e)}
        onPointerDown={handlePointerDown}
        onPointerUp={handlePointerUp}
        onPointerMove={handlePointerMove}
        onPointerLeave={handlePointerUp}
      >
        <circleGeometry args={props.id === props.selectedId ? enlargedBoxSize : boxSize} />
        {map && (
          <meshStandardMaterial
            toneMapped={false}
            map={map}
            color={color}
          />
        )}
      </mesh>
    </Draggable>
  );
};

Waypoint.propTypes = {
  id:                     PropTypes.number.isRequired,
  selectedId:             PropTypes.number,
  type:                   PropTypes.string.isRequired,
  logo:                   PropTypes.string,
  position:               PropTypes.arrayOf(PropTypes.number).isRequired,
  onClick:                PropTypes.func.isRequired,
  setIsMapControlEnabled: PropTypes.func,
};

Waypoint.defaultProps = {
  selectedId:             null,
  logo:                   '',
  setIsMapControlEnabled: () => {},
};

export default Waypoint;
